import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  name: 'creditPay/wholesaler',
  namespaced: true,
  state: {
    wholesalers: null,
    wholesalerAccounts: null,
  },
  getters: {
    getWholesaler: (state) => (uuid) => {
      return state.wholesalers?.find((e) => e.uuid === uuid)
    },
    getAvailableWholesalerAccounts(state) {
      return state.wholesalerAccounts?.filter((e) => e.isVerified && e.isVisible)
    },
  },
  mutations: {
    setWholesalers(state, wholesalers) {
      state.wholesalers = wholesalers
    },
    setWholesalerAccounts(state, accounts) {
      state.wholesalerAccounts = accounts
    },
  },
  actions: {
    async loadAllWholesalers({ state, commit }) {
      const { data } = await defaultApi.getAllWholesalers()
      commit('setWholesalers', data)
    },
    async loadAllWholesalerAccounts({ state, commit }) {
      const { data } = await defaultApi.getWholesalerAccounts()
      commit('setWholesalerAccounts', data)
    },
  },
}
